import { ReactNode } from "react";

// MUI
import { Grid, Dialog, DialogTitle, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

// Icons
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialogContent-root": {
		padding: theme.spacing(2),
	},
	"& .MuiDialogActions-root": {
		padding: theme.spacing(1),
	},
	"& .MuiDialog-paper": {
		borderRadius: "15px",
	},
	"& .MuiButtonBase-root.MuiButton-root": {
		fontFamily: "var(--font-family-v1) !important",
	},
	"& .MuiButtonBase-root.MuiButton-root.btn-pro-narrow": {
		fontFamily: "var(--font-family-v2) !important",
	},
}));

type BootstrapDialogTitleProps = {
	children: ReactNode;
	onClose: () => void;
	classes?: string;
	modalTitle?: string;
	headerStyle?: object;
	titleClasses?: string;
	className?: string;
	sx?: object;
	style?: object;
};
const BootstrapDialogTitle = (props: Readonly<BootstrapDialogTitleProps>) => {
	const { children, onClose, ...other } = props;

	return (
		<DialogTitle sx={{ width: "100%", height: "50px" }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 15,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</DialogTitle>
	);
};

type MainDialogComponentProps = {
	openDialog: boolean;
	onClose: () => void;
	onClick?: () => void;
	modalTitle?: string;
	titleClasses?: string;
	headerStyle?: object;
	width: number;
	children: ReactNode;
};
export default function MainDialogComponent(props: Readonly<MainDialogComponentProps>) {
	if (props.onClick) {
		props.onClick();
	}

	return (
		<BootstrapDialog
			maxWidth={false}
			onClose={props.onClose}
			aria-labelledby="customized-dialog-title"
			open={props.openDialog ?? false}
		>
			<Grid sx={{ width: props.width }}>
				<BootstrapDialogTitle className={props.titleClasses} style={props.headerStyle ?? {}} onClose={() => props.onClose()}>
					{props.modalTitle ?? ""}
				</BootstrapDialogTitle>

				<Grid>{props.children}</Grid>
			</Grid>
		</BootstrapDialog>
	);
}
